import { render, staticRenderFns } from "./UnNominateModal.vue?vue&type=template&id=83e73ecc&scoped=true"
import script from "./UnNominateModal.vue?vue&type=script&lang=js"
export * from "./UnNominateModal.vue?vue&type=script&lang=js"
import style0 from "./UnNominateModal.vue?vue&type=style&index=0&id=83e73ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e73ecc",
  null
  
)

export default component.exports